<div class="status-card total-status dis-flex">
    <img src="{{env.assetUrl}}/total_status_card_vector.svg" />
    <div class="content-wrapper total-card-status">
        <div class="count">
            <h1 class="font-medium m-b-0">{{total}}</h1>
        </div>
        <div class="title">
            <p class="b1 font-medium">{{ title }}</p>
        </div>
    </div>
    <div class="icon">
        <ng-icon name="hugeFolder01"></ng-icon>
    </div>
</div>